import { BaseModel } from '../../_metronic/shared/crud-table';
import { PaginatorState,ITableState, TableResponseModel, SortState, GroupingState } from '../../_metronic/shared/crud-table';

export interface Payment extends BaseModel {
    filter: {};
    paginator: PaginatorState;
    sorting: SortState;
    searchTerm: string;
    grouping: GroupingState;
    entityId: number | undefined;

    NroDePoliza: string;
    FechaDesde: Date;
    FechasHasta: Date;
    Prima: number;
    FechaPago: Date;
    TipoMovimiento: string
    NroRecibo: string
    NroRemesa: string;
    Saldo: number;
}

export class PaymentResponse {
    status: boolean;
    reference: string;
    autorization: string;
    tracking: string;
    mensaje: string;
}

export class PaymentItem {
    IdPoliza: string;
    Tarjeta: string;
    Monto: number;
    NombreTarjeta: string;
    NombrePagador: string;
    Reference: string;
    Autorization: string;
    Tracking: string;
    NroDePoliza: string;
    CustomerId:string;
};
